import {DataFetcher} from '@aboutyou/data-fetcher';
import {
  ContentPopperProps,
  SkeletonBlock,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useCoinsBannerSection} from '../useGetProductBulkSection';
import {CoinsBannerView} from './CoinsBannerView';

export const CoinsBanner: React.FC<{
  className?: string;
  ContentPopperLayoutComponent: ContentPopperProps['LayoutComponent'];
}> = props => {
  const req = useCoinsBannerSection();

  /**
   * We need to do this workaround because this whole coins banner section
   * can be optional, which is a wrong design on the api schema level
   * (if we have optional sections, we should use wrapper sections instead)
   */
  if (req.isFetched && !req.data) {
    return null;
  }

  return (
    <DataFetcher
      request={req}
      Loading={CoinsBannerSkeleton}
      Error={null}
      View={CoinsBannerView}
      viewProps={props}
    />
  );
};

const CoinsBannerSkeleton = styled(SkeletonBlock)`
  width: calc(100% - 1.75rem);
  height: 127px;

  ${tabletAndUpLinaria(`
    width: 100%;
    margin: 1.5rem 0 0 ;
  `)}
`;
